import useProperty from '@/hooks/api/useProperty';

export const useMenus = () =>
    useProperty('Menu', 'getMenuMenus', {
        initialState: [],
    });
